import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import storage from './storage'
import { pick } from 'lodash'
import http from '../plugins/http'
import { notification } from '../plugins/helpers'
import { AlertTypes } from '../plugins/alerts_types'
import minhasVendas, { getDefaultStateMinhasVendas } from './modules/minhasVendas'

Vue.use(Vuex)

const key = process.env.VUE_APP_SECURED ? '7fef9d93e91a3beb3f0cd3d2737a07a3' : 'rodobens'

const vuexLocal = new VuexPersistence({
  key,
  storage,
  reducer (state) {
    return pick(state, Object.keys(persistentes))
  }
})

const persistentes = {
  autenticar: false,
  senha_invalida: false,
  id_comissionado: null,
  id_ponto_venda: null,
  id_empresa: null,
  id_comissionado_venda: null,
  id_unidade_negocio: null,
  id_usuario: null,
  admin: null,
  super_admin: null,
  login: null,
  nome: null,
  token: null,
  filiais: [],
  empresas: [],
  unidades: [],
  comissionados: [],
  modalidades: {},
  filial: {},
  flavor: null,
  identificador_representante_tribanco: null,
  exibe_politica_vendas: false,
  limite_cotas_para_reservar_ativo: false,
  percentual_cotas_disponiveis_ativo: false,
  percentual_cotas_disponiveis: 1,
  quantidade_cotas_reservar: 1,
  procura_cidade_por_id: false,
  produtos: {},
  planos_venda: {},
  id_comissionado_master: null,
  exibe_contratos_painel: false,
  exibe_contratos_sistema: false,
  permite_logar_tela_login: false,
  permite_multiplicar_cota: false,
  id_usuario_interno: null,
  id_pedido_detalhes_venda: null,
  vendas_backoffice: false,
  login_sso: false,
  cd_ponto_venda: null,
  nm_ponto_venda: null,
  exibe_reenvio_whatsapp: null,
  exibe_reenvio_email: null,
  funcionalidades_permitidas: [],
  unidades_condicoes_venda: {},
  perfil_adm: 0,
  ambiente: false,
  ambiente_original: false,
  sessao_painel: false,
  _s: null,
  unidade_exclusiva: {},
  ids_empresas_permitidas: [],
  dados_usuario_logado: {},
  trocando_ambiente: false,
  permite_venda_todos_produtos: false,
  origem_acesso: '',
  jornada_venda: null,
  permissao_perfil: '',
  index_endereco_residencial: null,
  index_endereco_comercial: null,
  hierarquia_comercial: {},
  sinalMudarIdentidadeVisual: false,
  tempo_alertas_variados: 8000,
  tempo_alertas_erro: 20000,
  data_inicio_vigencia: null,
  data_fim_vigencia: null,
  desativar_selecao_comissionado: false,
  broker_fluxo_vendas_comum: false,
  broker_politica_vendas: false,
  nm_tabela_venda: null
}

const nao_persistentes = {
  loading: false,
  showAdditionalLoadingText: false,
  additionalLoadingText: '',
  alert: { visible: false, options: null },
  retry_resolvers: [],
  disponibility: true,
  notifications: [],
  CarregarLoading: null,
  emDeploy: false
}

function defaultState () {
  return {
    ...persistentes,
    ...nao_persistentes
  }
}

const state = defaultState()

const getters = {
  desativarSelecaoComissionado: (state) => state.desativar_selecao_comissionado,
  filial (state) {
    const filiais = state.filiais.filter(filial => filial.ID_Empresa === state.id_empresa)
    return filiais.length > 1 ? filiais : filiais[0]
  },
  async modalidadesEmpresa (state) {
    if (state.id_empresa && state.id_unidade_negocio) {
      const permite = await http.get(`/flavor-permite-todos-produtos/${state.flavor}`)
        .then(response => response.data.permite_venda_todos_produtos)
        .catch(() => {
          notification(AlertTypes.WARN, 'Caro parceiro, ocorreu um erro ao carregar algumas informações! Caso o produto que deseja visualizar, não esteja sendo exibido, sugerimos realizar o login novamente para que as informações sejam carregadas corretamente. Caso persista, entre em contato com a Área de Suporte!')
          return false
        })

      const result = await http.get('/compra/produtos_permitidos_empresa', {
        params: {
          id_empresa: state.id_empresa,
          id_unidade_negocio: state.id_unidade_negocio,
          id_flavor: state.flavor,
          permite_venda_todos_produtos: permite
        }
      }).then(result => result)
        .catch(() => {
          notification(AlertTypes.ERROR, 'Caro parceiro, ocorreu um erro ao carregar algumas informações! Caso o produto que deseja visualizar, não esteja sendo exibido, sugerimos realizar o login novamente para que as informações sejam carregadas corretamente. Caso persista, entre em contato com a Área de Suporte!')
          return null
        })

      if (!result || !result.data) {
        return []
      }

      const idsPermitidos = [...new Set(result.data.ProdutosPermitidosEmpresa.map(produto => produto.id_produto.toString()))]

      const modalidades = Object.keys(state.modalidades).map(modalidade_id => {
        const modalidade = state.modalidades[modalidade_id]

        const produtosFiltrados = modalidade.produtos.filter(produto => {
          const isPermitted = idsPermitidos.includes(produto.id_produto.toString())
          return isPermitted
        })

        return {
          ...modalidade,
          produtos: produtosFiltrados,
          modalidade: modalidade_id
        }
      })

      return modalidades.filter(modalidade => modalidade.produtos.length > 0)
    }
    return []
  },
  filiais (state) {
    return state.filiais
  },
  dadosRestricaoVenda (state) {
    return {
      'id_plano_venda': state.id_ponto_venda,
      'id_unidade_negocio': state.id_unidade_negocio || 0,
      'flavor': state.flavor
    }
  }
}

let loading = 0
let alertStack = []

const mutations = {
  setCarregarLoading (state, loading) {
    state.CarregarLoading = loading
  },
  resetCarregarLoading (state) {
    state.CarregarLoading = null
  },
  destroy () {
    const notifications = store.state.notifications
    store.replaceState(defaultState())
    store.state.notifications = notifications
    store.state.minhasVendas = getDefaultStateMinhasVendas()
  },
  setAccess (state, access) {
    const _s = access._s
    const login = access.login
    const sessao_painel = access.sessao_painel
    const vendas_backoffice = access.vendas_backoffice

    state._s = _s
    state.login = login
    state.sessao_painel = sessao_painel
    state.vendas_backoffice = vendas_backoffice
  },
  setState (state, data) {
    Object.assign(state, data)
  },
  setJornadaVenda (state, jornada) {
    state.jornada_venda = jornada
  },
  setDisponibility (state, status) {
    state.disponibility = status
  },
  setAdditionalLoadingText (state, additionalText) {
    state.additionalLoadingText = additionalText
  },
  setDeployStatus (state, status) {
    state.emDeploy = status
  },
  setShowAdditionalLoadingText (state, show) {
    state.showAdditionalLoadingText = show
  },
  setAutenticar (state, promise) {
    if (promise) {
      state.autenticar = true
      state.senha_invalida = !!promise.senha_invalida
      state.retry_resolvers.push(promise)
    } else {
      state.autenticar = false
      state.senha_invalida = false
      state.retry_resolvers = []
    }
  },
  setDesativarSelecaoComissionado (state, valor) {
    state.desativar_selecao_comissionado = valor
  },
  loadingStart (state) {
    state.loading = !!++loading
  },
  loadingDone (state) {
    let tempoTirarLoading = 0
    if (state.CarregarLoading) {
      state.CarregarLoading = true
      tempoTirarLoading = 750
    }
    setTimeout(() => {
      if (loading > 0) {
        state.loading = !!--loading
      }
    }, tempoTirarLoading)
  },
  alertShow (state, options) {
    if (state.alert.visible) {
      alertStack.push(options)
    } else {
      state.alert = { options, visible: true }
    }
  },
  notificationShow (state, alerta) {
    if (state.notifications.length >= 10) {
      state.notifications.slice(10, 1, alerta)
      return
    }
    state.notifications.push(alerta)
  },
  alertHide (state) {
    state.alert.visible = false
    if (alertStack.length) {
      setTimeout(() => {
        store.commit('alertShow', alertStack.shift())
      }, 150)
    }
  }
}

const actions = {
}

const plugins = [vuexLocal.plugin]

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins,

  modules: {
    minhasVendas
  }
})

export { persistentes }
export default store
